import React, { FunctionComponent } from 'react';
import { Helmet } from 'react-helmet';
import { graphql, useStaticQuery } from 'gatsby';

interface SiteMetadataProps {
  location?: {
    pathname?: string;
  };
}

const SiteMetadata: FunctionComponent<SiteMetadataProps> = ({
  location: { pathname },
}) => {
  const {
    site: {
      siteMetadata: { siteUrl, title, description },
    },
  } = useStaticQuery(graphql`
    query SiteMetadata {
      site {
        siteMetadata {
          siteUrl
          title
          description
        }
      }
    }
  `);

  return (
    <Helmet defer={false} defaultTitle={title} titleTemplate={`%s | ${title}`}>
      <html lang="en" className="no-js" />
      <link rel="canonical" href={`${siteUrl}${pathname}`} />
      <meta
        name="viewport"
        content="width=device-width,initial-scale=1,shrink-to-fit=no,viewport-fit=cover"
      />
      <meta name="description" content={description} />

      <meta property="og:url" content={siteUrl} />
      <meta property="og:type" content="website" />
      <meta property="og:locale" content="en" />
    </Helmet>
  );
};

export default SiteMetadata;
